import { environment } from '../../constants';
import { AnalyticsAdapter, AnalyticsEventCategory, AnalyticsEventName } from './AnalyticsAdapter';
import ReactGA from 'react-ga4';

const GA_MEASUREMENT_ID = 'G-LP6R8Y8C8T';

export class GoogleAnalytics implements AnalyticsAdapter {
  public init() {
    ReactGA.initialize(GA_MEASUREMENT_ID, {
      gaOptions: {
        debug_mode: environment.NODE_ENV !== 'production',
      },
      gtagOptions: {
        debug_mode: environment.NODE_ENV !== 'production',
      },
    });
  }

  public trackPageView(path: string) {
    ReactGA.send({ hitType: 'pageview', page: path });
  }

  public trackEvent(input: {
    action: AnalyticsEventName;
    category: AnalyticsEventCategory;
    label?: string;
    value?: number;
    params?: { [key: string]: any };
  }) {
    ReactGA.event(input.action, {
      category: input.category,
      label: input.label,
      value: input.value,
      ...(input.params || {}),
    });
  }
}
